import {
  ACCOMMODATION_SERVICES_SECTOR,
  ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
  ARTS_ENTERTAINMENT_SECTOR,
  CONSTRUCTION_SECTOR,
  EDUCATIONAL_SERVICES_SECTOR,
  FINANCE_AND_INSURANCE_SECTOR,
  FISHING_AND_HUNTING_SECTOR,
  HEALTH_CARE_SECTOR,
  INFORMATION_SECTOR,
  MANAGEMENT_OF_COMPANIES_SECTOR,
  MANUFACTURING_SECTOR,
  MINING_QUARRYING_OIL_AND_GAS_SECTOR,
  OTHER_SERVICES_SECTOR,
  PUBLIC_ADMINISTRATION_SECTOR,
  REAL_ESTATE_SECTOR,
  RETAIL_TRADE_SECTOR,
  SCIENTIFIC_SERVICES_SECTOR,
  TRANSPORTATION_AND_WAREHOUSING_SECTOR,
  UTILITIES_SECTOR,
  WHOLESALE_TRADE_SECTOR,
} from '../industrySectorOptions';
import {
  ACCOMMODATION_SUB_SECTOR,
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  ADMINISTRATIVE_SERVICE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR,
  AIR_TRANSPORTATION_SUB_SECTOR,
  AMBULATORY_CARE_SUB_SECTOR,
  AMUSEMENT_INDUSTRY_SUB_SECTOR,
  ANIMAL_AND_AGRICULTURE_SUB_SECTOR,
  APPAREL_MANUFACTURING_SUB_SECTOR,
  BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR,
  BROADCASTING_PROVIDER_SUB_SECTOR,
  BUILDING_CONSTRUCTION_SUB_SECTOR,
  BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
  CHEMICAL_MANUFACTURING_SUB_SECTOR,
  CLOTHING_RETAILERS_SUB_SECTOR,
  COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  COURIERS_SUB_SECTOR,
  CREDIT_INTERMEDIATION_SUB_SECTOR,
  CROP_PRODUCTION_SUB_SECTOR,
  DURABLE_GOODS_SUB_SECTOR,
  EDUCATIONAL_SERVICES_SUB_SECTOR,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  FABRICATED_METAL_MANUFACTURING_SUB_SECTOR,
  FISHING_HUNTING_TRAPPING_SUB_SECTOR,
  FOOD_MANUFACTURING_SUB_SECTOR,
  FOOD_RETAILERS_SUB_SECTOR,
  FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR,
  FORESTRY_AND_LOGGING_SUB_SECTOR,
  FUNDS_TRUSTS_SUB_SECTOR,
  FURNITURE_MANUFACTURING_SUB_SECTOR,
  FURNITURE_RETAILERS_SUB_SECTOR,
  GASOLINE_DEALERS_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR,
  HOSPITALS_SUB_SECTOR,
  INSURANCE_CARRIERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LAUNDRY_SERVICE_SUB_SECTOR,
  LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MACHINERY_MANUFACTURING_SUB_SECTOR,
  MERCHANDISE_RETAILERS_SUB_SECTOR,
  MINING_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MISCELLANEOUS_MANUFACTURING_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MOTION_PIC_INDUSTRIES_SUB_SECTOR,
  MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  NONDURABLE_GOODS_SUB_SECTOR,
  NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR,
  NURSING_FACILITIES_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PAPER_MANUFACTURING_SUB_SECTOR,
  PERFORMING_ARTS_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  PIPELINE_TRANSPORTATION_SUB_SECTOR,
  PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRIMARY_METAL_MANUFACTURING_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  PUBLISHING_INDUSTRIES_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  REAL_ESTATE_SUB_SECTOR,
  RELIGIOUS_SUB_SECTOR,
  RENTAL_AND_LEASING_SUB_SECTOR,
  REPAIR_AND_MAINTENANCE_SUB_SECTOR,
  SCENIC_TRANSPORTATION_SUB_SECTOR,
  SECURITIES_COMMODITY_SUB_SECTOR,
  SOCIAL_ASSISTANCE_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR,
  SPORTING_GOODS_RETAILERS_SUB_SECTOR,
  SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR,
  TELECOMMUNICATION_SUB_SECTOR,
  TEXTILE_MILLS_SUB_SECTOR,
  TEXTILE_PRODUCT_MILLS_SUB_SECTOR,
  TRANSIT_TRANSPORTATION_SUB_SECTOR,
  TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  TRUCK_TRANSPORTATION_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WASTE_MANAGEMENT_SUB_SECTOR,
  WATER_TRANSPORTATION_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
  WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR,
} from '../industrySubSectorOptions';

export const SUB_SECTOR_OPTIONS_DEU = {
  [FISHING_AND_HUNTING_SECTOR]: [
    { value: CROP_PRODUCTION_SUB_SECTOR, label: 'Pflanzenbau' },
    { value: ANIMAL_AND_AGRICULTURE_SUB_SECTOR, label: 'Tierproduktion und Aquakultur' },
    { value: FORESTRY_AND_LOGGING_SUB_SECTOR, label: 'Forstwirtschaft und Holzeinschlag' },
    { value: FISHING_HUNTING_TRAPPING_SUB_SECTOR, label: 'Fischerei, Jagd und Fallenstellerei' },
    {
      value: AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR,
      label: 'Erbringung von Dienstleistungen für Landwirtschaft und Forstwirtschaft',
    },
  ],
  [MINING_QUARRYING_OIL_AND_GAS_SECTOR]: [
    { value: OIL_GAS_EXTRACTION_SUB_SECTOR, label: 'Erdöl- und Erdgasförderung' },
    { value: MINING_SUB_SECTOR, label: 'Bergbau (ohne Erdöl und Erdgas)' },
    {
      value: MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
      label: 'Erbringung von Dienstleistungen für den Bergbau',
    },
  ],
  [UTILITIES_SECTOR]: [],
  [CONSTRUCTION_SECTOR]: [
    { value: BUILDING_CONSTRUCTION_SUB_SECTOR, label: 'Hochbau' },
    {
      value: HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR,
      label: 'Tief- und Ingenieurbau',
    },
    {
      value: SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR,
      label: 'Ausbaugewerbe und spezialisierte Bautätigkeiten',
    },
  ],
  [MANUFACTURING_SECTOR]: [
    { value: FOOD_MANUFACTURING_SUB_SECTOR, label: 'Herstellung von Nahrungsmitteln' },
    {
      value: BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Getränken und Tabakwaren',
    },
    { value: TEXTILE_MILLS_SUB_SECTOR, label: 'Spinnereien und Webereien' },
    {
      value: TEXTILE_PRODUCT_MILLS_SUB_SECTOR,
      label: 'Herstellung von Textilwaren (ohne Bekleidung)',
    },
    { value: APPAREL_MANUFACTURING_SUB_SECTOR, label: 'Herstellung von Bekleidung' },
    {
      value: LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Leder und Lederwaren',
    },
    {
      value: WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Holz-, Flecht- und Korbwaren',
    },
    {
      value: PAPER_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Papier, Pappe und Waren daraus',
    },
    {
      value: PRINTING_MANUFACTURING_SUB_SECTOR,
      label: 'Druckereien und mit dem Druck verbundene Dienstleistungen',
    },
    {
      value: PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Kokerei- und Mineralölerzeugnissen',
    },
    { value: CHEMICAL_MANUFACTURING_SUB_SECTOR, label: 'Chemische Industrie' },
    {
      value: PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Gummi- und Kunststoffwaren',
    },
    {
      value: NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Glaswaren, Keramik, Steinen und sonstigen nichtmetallischen mineralischen Erzeugnissen',
    },
    { value: PRIMARY_METAL_MANUFACTURING_SUB_SECTOR, label: 'Erzeugung von Metallen' },
    {
      value: FABRICATED_METAL_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Metallerzeugnissen',
    },
    { value: MACHINERY_MANUFACTURING_SUB_SECTOR, label: 'Maschinenbau' },
    {
      value: COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Datenverarbeitungsgeräten, elektronischen und optischen Erzeugnissen',
    },
    {
      value: ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von elektrischen Ausrüstungen, Geräten und Komponenten',
    },
    {
      value: TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Kraftwagen und sonstigen Transportmitteln',
    },
    {
      value: FURNITURE_MANUFACTURING_SUB_SECTOR,
      label: 'Herstellung von Möbeln und sonstigen Einrichtungsgegenständen',
    },
    { value: MISCELLANEOUS_MANUFACTURING_SUB_SECTOR, label: 'Sonstige verarbeitende Industrie' },
  ],
  [WHOLESALE_TRADE_SECTOR]: [
    {
      value: DURABLE_GOODS_SUB_SECTOR,
      label: 'Großhandel mit langlebigen Konsumgütern',
    },
    {
      value: NONDURABLE_GOODS_SUB_SECTOR,
      label: 'Großhandel mit nicht langlebigen Konsumgütern',
    },
    {
      value: AGENTS_AND_BROKERS_SUB_SECTOR,
      label: 'Handelsvermittlung und Großhandelsagenturen',
    },
  ],
  [RETAIL_TRADE_SECTOR]: [
    {
      value: MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR,
      label: 'Einzelhandel mit Kraftfahrzeugen und Kfz-Teilen',
    },
    {
      value: BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
      label: 'Einzelhandel mit Bau- und Heimwerkerbedarf sowie Garten- und Landschaftsbedarf',
    },
    {
      value: FOOD_RETAILERS_SUB_SECTOR,
      label: 'Einzelhandel mit Nahrungs- und Genussmitteln',
    },
    {
      value: FURNITURE_RETAILERS_SUB_SECTOR,
      label: 'Einzelhandel mit Möbeln, Wohnaccessoires, Elektronik und Haushaltsgeräten',
    },
    {
      value: MERCHANDISE_RETAILERS_SUB_SECTOR,
      label: 'Einzelhandel mit Waren verschiedener Art (Kaufhäuser u. Ä.)',
    },
    {
      value: HEALTH_RETAILERS_SUB_SECTOR,
      label: 'Einzelhandel mit Gesundheits- und Körperpflegeprodukten',
    },
    {
      value: GASOLINE_DEALERS_SUB_SECTOR,
      label: 'Tankstellen und Brennstoffhändler',
    },
    {
      value: CLOTHING_RETAILERS_SUB_SECTOR,
      label: 'Einzelhandel mit Bekleidung, Accessoires, Schuhen und Schmuck',
    },
    {
      value: SPORTING_GOODS_RETAILERS_SUB_SECTOR,
      label: 'Einzelhandel mit Sportartikeln, Freizeit-, Musikinstrumenten-, Buch- und sonstigen Sortimenten',
    },
  ],
  [TRANSPORTATION_AND_WAREHOUSING_SECTOR]: [
    { value: AIR_TRANSPORTATION_SUB_SECTOR, label: 'Luftverkehr' },
    { value: RAIL_TRANSPORTATION_SUB_SECTOR, label: 'Schienenverkehr' },
    { value: WATER_TRANSPORTATION_SUB_SECTOR, label: 'Schifffahrt' },
    { value: TRUCK_TRANSPORTATION_SUB_SECTOR, label: 'Güterkraftverkehr' },
    {
      value: TRANSIT_TRANSPORTATION_SUB_SECTOR,
      label: 'Öffentlicher Personennahverkehr und sonstiger Land-Personenverkehr',
    },
    { value: PIPELINE_TRANSPORTATION_SUB_SECTOR, label: 'Transport durch Rohrfernleitungen' },
    {
      value: SCENIC_TRANSPORTATION_SUB_SECTOR,
      label: 'Ausflugs- und Sightseeing-Verkehr',
    },
    {
      value: SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR,
      label: 'Erbringung von sonstigen Dienstleistungen für den Verkehr',
    },
    { value: POSTAL_SERVICE_SUB_SECTOR, label: 'Postdienste' },
    {
      value: COURIERS_SUB_SECTOR,
      label: 'Kurier-, Express- und Paketdienste',
    },
    { value: WAREHOUSING_AND_STORAGE_SUB_SECTOR, label: 'Lagerei und Lagerlogistik' },
  ],
  [INFORMATION_SECTOR]: [
    {
      value: MOTION_PIC_INDUSTRIES_SUB_SECTOR,
      label: 'Film-, Video- und Tonaufnahmewirtschaft',
    },
    { value: PUBLISHING_INDUSTRIES_SUB_SECTOR, label: 'Verlagswesen' },
    {
      value: BROADCASTING_PROVIDER_SUB_SECTOR,
      label: 'Rundfunk und Content-Anbieter',
    },
    { value: TELECOMMUNICATION_SUB_SECTOR, label: 'Telekommunikation' },
    {
      value: COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
      label: 'Anbieter von IT-Infrastruktur, Datenverarbeitung, Webhosting und verwandten Diensten',
    },
    {
      value: WEB_SEARCH_PORTALS_SUB_SECTOR,
      label: 'Web-Suchportale, Bibliotheken, Archive und sonstige Informationsdienstleistungen',
    },
  ],
  [FINANCE_AND_INSURANCE_SECTOR]: [
    {
      value: MONETARY_BANK_SUB_SECTOR,
      label: 'Währungsbehörden und Zentralbanken',
    },
    {
      value: CREDIT_INTERMEDIATION_SUB_SECTOR,
      label: 'Kreditintermediation und verwandte Tätigkeiten',
    },
    {
      value: SECURITIES_COMMODITY_SUB_SECTOR,
      label: 'Wertpapier-, Terminbörsen- und sonstige Finanzinvestitions- und damit verbundene Tätigkeiten',
    },
    {
      value: INSURANCE_CARRIERS_SUB_SECTOR,
      label: 'Versicherungsunternehmen und damit verbundene Dienstleistungen',
    },
    {
      value: FUNDS_TRUSTS_SUB_SECTOR,
      label: 'Fonds, Trusts und sonstige Finanzvehikel',
    },
  ],
  [REAL_ESTATE_SECTOR]: [
    { value: REAL_ESTATE_SUB_SECTOR, label: 'Grundstücks- und Wohnungswesen' },
    { value: RENTAL_AND_LEASING_SUB_SECTOR, label: 'Vermietung und Verleih' },
    {
      value: LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
      label: 'Verpachtung nichtfinanzieller immaterieller Vermögenswerte (ohne urheberrechtlich geschützte Werke)',
    },
  ],
  [SCIENTIFIC_SERVICES_SECTOR]: [],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [],
  [ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR]: [
    {
      value: ADMINISTRATIVE_SERVICE_SUB_SECTOR,
      label: 'Administrative Dienste und Unterstützungsleistungen',
    },
    {
      value: WASTE_MANAGEMENT_SUB_SECTOR,
      label: 'Abfallwirtschaft und Sanierungsdienste',
    },
  ],
  [EDUCATIONAL_SERVICES_SECTOR]: [{ value: EDUCATIONAL_SERVICES_SUB_SECTOR, label: 'Bildungsdienstleistungen' }],
  [HEALTH_CARE_SECTOR]: [
    {
      value: AMBULATORY_CARE_SUB_SECTOR,
      label: 'Ambulante Gesundheitsdienste',
    },
    { value: HOSPITALS_SUB_SECTOR, label: 'Krankenhäuser' },
    {
      value: NURSING_FACILITIES_SUB_SECTOR,
      label: 'Pflege- und Betreuungseinrichtungen',
    },
    { value: SOCIAL_ASSISTANCE_SUB_SECTOR, label: 'Soziale Hilfsdienste' },
  ],
  [ARTS_ENTERTAINMENT_SECTOR]: [
    {
      value: PERFORMING_ARTS_SUB_SECTOR,
      label: 'Darstellende Künste, Zuschauersport und verwandte Branchen',
    },
    {
      value: MUSEUMS_SUB_SECTOR,
      label: 'Museen, historische Stätten und ähnliche Einrichtungen',
    },
    {
      value: AMUSEMENT_INDUSTRY_SUB_SECTOR,
      label: 'Freizeit-, Glücksspiel- und Erholungswirtschaft',
    },
  ],
  [ACCOMMODATION_SERVICES_SECTOR]: [
    { value: ACCOMMODATION_SUB_SECTOR, label: 'Beherbergungsgewerbe' },
    {
      value: FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR,
      label: 'Gastronomie und Schankwirtschaften',
    },
  ],
  [OTHER_SERVICES_SECTOR]: [
    { value: REPAIR_AND_MAINTENANCE_SUB_SECTOR, label: 'Reparatur und Instandhaltung' },
    {
      value: LAUNDRY_SERVICE_SUB_SECTOR,
      label: 'Persönliche Dienste und Wäschereidienste',
    },
    {
      value: RELIGIOUS_SUB_SECTOR,
      label: 'Religiöse Organisationen, Stiftungen, Bürger-, Berufs- und ähnliche Vereinigungen',
    },
    { value: PRIVATE_HOUSEHOLDS_SUB_SECTOR, label: 'Private Haushalte' },
  ],
  [PUBLIC_ADMINISTRATION_SECTOR]: [
    {
      value: EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
      label: 'Exekutive, Legislative und sonstige allgemeine Regierungstätigkeiten',
    },
    {
      value: JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
      label: 'Justiz, öffentliche Ordnung und Sicherheitsdienste',
    },
    {
      value: ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
      label: 'Verwaltung von Programmen im Bereich Arbeit, Soziales und Personal',
    },
    {
      value: ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
      label: 'Verwaltung von Umweltschutz- und Umweltqualitätsprogrammen',
    },
    {
      value: ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
      label: 'Verwaltung von Wohnungsprogrammen, Stadtplanung und kommunaler Entwicklung',
    },
    {
      value: ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
      label: 'Verwaltung wirtschaftspolitischer Programme',
    },
    {
      value: SPACE_RESEARCH_SUB_SECTOR,
      label: 'Weltraumforschung und -technologie',
    },
    {
      value: NATIONAL_SECURITY_SUB_SECTOR,
      label: 'Nationale Sicherheit und internationale Angelegenheiten',
    },
  ],
};
